import { createContext, useContext } from "react";
import ActivityStore from "./activityStore";
import CommonStore from "./commonStore";
import ModalStore from "./modalStore";
import ProfileStore from "./profileStore";
import SGPersonaStore from "./SGPersonaStore";
import SGTDepartamentoStore from "./SGTDepartamentoStore";
import SGTMunicipioStore from "./SGTMunicipioStore";
import SGTEntidadStore from "./SGTEntidadesStore";
import CCTiposDeCuentasStore from "./CCTiposDeCuentasStore";
import CCTiposDeDocumentosStore from "./CCTiposDeDocumentosStore";
import CCTiposDeTransaccionStore from "./CCTiposDeTransaccionStore";
import CCTTiposTransXTipoCtaStore from "./CCTTiposTransXTipoCtaStore";
import InscriptionsStore from "./InscriptionsStore";
import UserStore from "./userStore";
import CCTCuentaStore from "./CCTCuentaStore";
import CCTMovimientoStore from "./CCTMovimientoStore";
import SaldosReporteStore from "./SaldosReporteStore";
import CuentaDPIStore from './CuentaDPI'
import CuotasStore from "./CuotasStore";

import CargaStore from "./cargaStore";
import CargaInscripcionStore from './CargaInscripcionStore'

import CCTOperacionStore from "./CCTOperacionesStore"
import CCTMovimientoReporteStore from "./CCTMovimientoReporte";
import ExoneracionesStore from "./ExoneracionesStore";
import recibosStore from "./recibosStore";
import CATCursosStore from "./CATCursos";
import CATConveniosStore from "./CATConveniosStore";
import CATModulosStore from "./CATModulosStore";
import PassStore from "./PassStore";
import RolesStore from "./RolesStore";
import PagoAgenciaStore from "./PagoAgencia";
import ReporteInscritosStore from "./ReporteInscritosStore";
import ReporteBanruralStore from "./ReporteBanruralStore";
import ListaDocentesStore from "./ListaDocentesStore";
import ListaDelegacionesStore from './DelegacionesStore';
import { SGTComunidad } from "../models/SGTComunidades";
import SGTComunidadStore from "./SGTComunidadStore";
import RecuperarUsuarioStore from "./RecuperarUsuarioStore";
import UsersListStore from "./UsersListStore";


interface Store {
    activityStore: ActivityStore;
    commonStore: CommonStore;
    userStore: UserStore;
    modalStore: ModalStore;
    SGPersonaStore: SGPersonaStore;
    SGTDepartamentoStore: SGTDepartamentoStore;
    SGTMunicipioStore: SGTMunicipioStore;
    SGTComunidadStore: SGTComunidadStore;
    SGTEntidadStore: SGTEntidadStore;
    CCTiposDeCuentasStore: CCTiposDeCuentasStore;
    CCTiposDeDocumentosStore: CCTiposDeDocumentosStore;
    CCTiposDeTransaccionStore: CCTiposDeTransaccionStore;
    CCTTiposTransXTipoCtaStore: CCTTiposTransXTipoCtaStore;
    CCTCuentaStore: CCTCuentaStore;
    CCTMovimientoStore: CCTMovimientoStore;
    CCTOperacionStore : CCTOperacionStore;
    InscriptionsStore: InscriptionsStore;
    CCTMovimientoReporteStore: CCTMovimientoReporteStore;
    profileStore: ProfileStore;
    cargaStore : CargaStore;
    CuentaDPIStore: CuentaDPIStore;
    SaldosReporteStore: SaldosReporteStore;
    CuotasStore: CuotasStore;
    ExoneracionesStore: ExoneracionesStore;
    recibosStore : recibosStore;
    CATCursosStore: CATCursosStore;
    CargaInscripcionStore: CargaInscripcionStore;
    CATConveniosStore: CATConveniosStore
    CATModulosStore: CATModulosStore
    RecuperarUsuarioStore: RecuperarUsuarioStore
    PassStore: PassStore;
    RolesStore: RolesStore;
    PagoAgenciaStore: PagoAgenciaStore;
    ReporteInscritosStore: ReporteInscritosStore
    ReporteBanruralStore: ReporteBanruralStore
    ListaDocentesStore: ListaDocentesStore
    ListaDelegacionesStore: ListaDelegacionesStore
    UsersListStore: UsersListStore
}

export const store: Store = {
    activityStore: new ActivityStore(),
    commonStore: new CommonStore(),
    userStore: new UserStore(),
    modalStore: new ModalStore(),
    SGPersonaStore: new SGPersonaStore(),
    SGTDepartamentoStore: new SGTDepartamentoStore(),
    SGTMunicipioStore: new SGTMunicipioStore(),
    SGTComunidadStore: new SGTComunidadStore(),
    SGTEntidadStore: new SGTEntidadStore(),
    CCTiposDeCuentasStore: new CCTiposDeCuentasStore(),
    CCTiposDeDocumentosStore: new CCTiposDeDocumentosStore(),
    CCTiposDeTransaccionStore: new CCTiposDeTransaccionStore(),
    CCTTiposTransXTipoCtaStore: new CCTTiposTransXTipoCtaStore(),
    CCTCuentaStore: new CCTCuentaStore(),
    CCTMovimientoStore: new CCTMovimientoStore(),
    CCTOperacionStore: new CCTOperacionStore(),
    InscriptionsStore: new InscriptionsStore(),
    SaldosReporteStore: new SaldosReporteStore(),
    CCTMovimientoReporteStore: new CCTMovimientoReporteStore(),
    CuentaDPIStore: new CuentaDPIStore(),
    profileStore: new ProfileStore(),
    cargaStore : new CargaStore(),
    CuotasStore: new CuotasStore(),
    ExoneracionesStore: new ExoneracionesStore(),
    recibosStore: new recibosStore(),
    CATCursosStore: new CATCursosStore(),
    CargaInscripcionStore: new CargaInscripcionStore(),
    CATConveniosStore: new CATConveniosStore(),
    CATModulosStore: new CATModulosStore(),
    RecuperarUsuarioStore: new RecuperarUsuarioStore(),
    PassStore: new PassStore(),
    RolesStore: new RolesStore(),
    PagoAgenciaStore: new PagoAgenciaStore,
    ReporteInscritosStore: new ReporteInscritosStore(),
    ReporteBanruralStore: new ReporteBanruralStore(),
    ListaDocentesStore: new ListaDocentesStore(),
    ListaDelegacionesStore: new ListaDelegacionesStore(),
    UsersListStore: new UsersListStore()
}

export const StoreContext = createContext(store);

export function useStore() {
    return useContext(StoreContext);
}